import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to RoofGuard",
    title: "Top-Quality {Roofing Solutions} for Your Home",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to RoofGuard",
    title: "Expert {Roof Installation Services} for Your Property",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to RoofGuard",
    title: "Custom {Roofing Designs} Tailored to Your Needs",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
];

export default home;